import { render, staticRenderFns } from "./AssignmentDetailsRenderer.vue?vue&type=template&id=f5784562&"
import script from "./AssignmentDetailsRenderer.vue?vue&type=script&lang=js&"
export * from "./AssignmentDetailsRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports